import { defineMessages } from 'react-intl'

export default defineMessages({
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  displayNameLabel: {
    id: 'DisplayName',
    defaultMessage: 'Display Name'
  },
  displayNamePlaceholder: {
    id: 'OrganizationUserAttributes.Form.DisplayName.Placeholder',
    defaultMessage: 'Name your users see'
  },
  descriptionLabel: {
    id: 'Description',
    defaultMessage: 'Description'
  },
  descriptionPlaceholder: {
    id: 'OrganizationUserAttributes.Form.Description.Placeholder',
    defaultMessage: 'A brief description'
  },
  typeLabel: {
    id: 'Type',
    defaultMessage: 'Type'
  },
  typeBinary: {
    id: 'OrganizationUserAttributes.Type.Binary',
    defaultMessage: 'Binary'
  },
  typeBoolean: {
    id: 'OrganizationUserAttributes.Type.Boolean',
    defaultMessage: 'Boolean'
  },
  typeComplex: {
    id: 'OrganizationUserAttributes.Type.Complex',
    defaultMessage: 'Complex'
  },
  typeDateTime: {
    id: 'OrganizationUserAttributes.Type.Datetime',
    defaultMessage: 'Date/Time'
  },
  typeDecimal: {
    id: 'OrganizationUserAttributes.Type.Decimal',
    defaultMessage: 'Decimal'
  },
  typeInteger: {
    id: 'OrganizationUserAttributes.Type.Integer',
    defaultMessage: 'Number'
  },
  typeString: {
    id: 'OrganizationUserAttributes.Type.String',
    defaultMessage: 'Text'
  },
  scimAttributeNameLabel: {
    id: 'OrganizationUserAttributes.Form.SCIMAttributeName.Label',
    defaultMessage: 'SCIM Attribute Name'
  },
  scimAttributeNamePlaceholder: {
    id: 'OrganizationUserAttributes.Form.SCIMAttributeName.Placeholder',
    defaultMessage: 'SCIM compliant attribute name'
  },
  scimAttributeNameDescription: {
    id: 'OrganizationUserAttributes.Form.SCIMAttributeName.Description',
    defaultMessage:
      'Must start with an alphabetic character and subsequently only contain alphanumeric or special (_$-) characters.'
  },
  scimAttributeNameFirstCharacterError: {
    id: 'OrganizationUserAttributes.Form.SCIMAttributeName.FirstCharError',
    defaultMessage: 'Name must start with an alphabetic character.'
  },
  scimAttributeNameNthCharacterError: {
    id: 'OrganizationUserAttributes.Form.SCIMAttributeName.NthCharError',
    defaultMessage: 'Name must contain only alphanumeric or special (_$-) characters.'
  },
  targetableLabel: {
    id: 'OrganizationUserAttributes.Form.Targetable.Label',
    defaultMessage: 'Target?'
  },
  targetableDescription: {
    id: 'OrganizationUserAttributes.Form.Targetable.Description',
    defaultMessage:
      'When enabled this attribute can be used in areas like Publisher and Survey to select portions of your user population.'
  },
  cancelButton: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  submitButton: {
    id: 'Create',
    defaultMessage: 'Create'
  }
})
